(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const root = document.currentScript.closest('.section-header') || document;
    const nav = root.querySelector('.n-pillnav');
    if (!nav) return;

    const items = Array.from(nav.querySelectorAll('.n-pillnav__item.has-children'));

    const closeAll = () => {
      items.forEach((li) => {
        li.classList.remove('is-open');
        const btn = li.querySelector('.n-pillnav__link');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    };

    items.forEach((li) => {
      const btn = li.querySelector('button.n-pillnav__link');
      if (!btn) return;

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = li.classList.contains('is-open');
        closeAll();
        if (!isOpen) {
          li.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (!nav.contains(e.target)) closeAll();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });
  })();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
                  (() => {
                    const ACC_SELECTOR = 'details.n-accjs';
                    const CONTENT_SELECTOR = '.n-accjs__content';

                    const animateOpen = (details, content) => {
                      // Set open first so inner content is measurable (and :open CSS applies)
                      details.open = true;

                      // Start from 0
                      content.style.height = '0px';

                      // Measure final height
                      const target = content.scrollHeight;

                      // Animate to final height
                      requestAnimationFrame(() => {
                        content.style.height = `${target}px`;
                      });

                      const onEnd = (e) => {
                        if (e.propertyName !== 'height') return;
                        content.style.height = 'auto'; // allow responsive content, images, etc.
                        content.removeEventListener('transitionend', onEnd);
                      };
                      content.addEventListener('transitionend', onEnd);
                    };

                    const animateClose = (details, content) => {
                      // Fix current height (auto -> px), then animate to 0
                      const start = content.scrollHeight;
                      content.style.height = `${start}px`;

                      requestAnimationFrame(() => {
                        content.style.height = '0px';
                      });

                      const onEnd = (e) => {
                        if (e.propertyName !== 'height') return;
                        details.open = false; // remove open at the end (keeps keyboard/ARIA correct)
                        content.removeEventListener('transitionend', onEnd);
                      };
                      content.addEventListener('transitionend', onEnd);
                    };

                    const initOne = (details) => {
                      const summary = details.querySelector('summary');
                      const content = details.querySelector(CONTENT_SELECTOR);
                      if (!summary || !content) return;

                      // Ensure initial state is consistent
                      if (details.open) {
                        content.style.height = 'auto';
                      } else {
                        content.style.height = '0px';
                      }

                      summary.addEventListener('click', (e) => {
                        e.preventDefault(); // stop native snap-open/close

                        // If currently animating, lock to current computed height
                        const computed = window.getComputedStyle(content).height;
                        content.style.height = computed;

                        if (!details.open) {
                          animateOpen(details, content);
                        } else {
                          animateClose(details, content);
                        }
                      });
                    };

                    const initAll = (root = document) => {
                      root.querySelectorAll(ACC_SELECTOR).forEach(initOne);
                    };

                    // Initial
                    initAll();

                    // Shopify editor: re-init when section reloads
                    document.addEventListener('shopify:section:load', (e) => {
                      initAll(e.target);
                    });
                  })();
                
  } catch(e) { console.error(e); }
})();
})();
